import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#FF5537",
              d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5c-4.694 0-8.5 3.806-8.5 8.5s3.806 8.5 8.5 8.5 8.5-3.806 8.5-8.5-3.806-8.5-8.5-8.5zm0 2.75c.38 0 .693.282.743.648L12.75 7v4.25H17c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L17 12.75h-4.25V17c0 .414-.336.75-.75.75-.38 0-.693-.282-.743-.648L11.25 17v-4.25H7c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743L7 11.25h4.25V7c0-.414.336-.75.75-.75z",
              transform: "translate(-331 -516) translate(323 508) translate(8 8)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }